if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[data-submit-button][type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.stickyATCSubmitButton = this.querySelector('[data-sticky-atc-submit-button][type="submit"]');
        this.stickyATCSubmitButton = this.querySelector('[data-sticky-atc-submit-button][type="submit"]');
        this.stickyATCSubmitButtonText = this.stickyATCSubmitButton.querySelector('span');
        this.stickyATCSubmitButtonPrice = this.stickyATCSubmitButton.querySelector('[data-sticky-atc-price]');
        this.stickyATC = this.querySelector('[data-sticky-atc]');
        this.stickyATCNotifyButton = this.querySelector('[data-notify-trigger]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';

        if (this.stickyATC) {
          this.initStickyATC();
        }

        this.stickyATCNotifyButton.addEventListener('click', () => {
          this.querySelector('#attn-waitlist-trigger-btn')?.click();
        });

        this.attentiveAppContainer = this.querySelector('[data-attentive-trigger-container]');

        if (this.attentiveAppContainer) this.initAttentiveMountObserver();
        this.attentiveAppTrigger = this.querySelector('#attn-waitlist-trigger');
        this.initAttentiveObserver();
      }

      initAttentiveMountObserver() {
        const config = { attributes: true, childList: true };
        const callback = () => {
          if (this.attentiveAppTrigger) {
            this.attentiveAppContainer.classList.remove('hidden');
            this.attentiveAppMountObserver.disconnect();
            console.log('disconnected becuase of mount');
          }
        };
        this.attentiveAppMountObserver = new MutationObserver(callback);

        this.attentiveAppMountObserver.observe(this.attentiveAppContainer, config);
      }

      initAttentiveObserver() {
        const config = { attributes: true, childList: true };

        const callback = () => {
          const showNotifyButton = Boolean(this.attentiveAppTrigger.dataset.productId);
          this.stickyATCNotifyButton.classList.toggle('hidden', !showNotifyButton);
          this.stickyATCSubmitButton.classList.toggle('hidden', showNotifyButton);
        };
        const attentiveAppMutationObserver = new MutationObserver(callback);

        attentiveAppMutationObserver.observe(this.attentiveAppTrigger, config);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('[data-buy-button-text]').classList.add('opacity-30');
        this.querySelector('[data-loading-spinner]').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('[data-buy-button-text]').classList.remove('opacity-30');
            this.querySelector('[data-loading-spinner]').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('[data-product-form-error-message-wrapper]');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('[data-product-form-error-message]');

        this.errorMessageWrapper.classList.toggle('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButtons(disable = true, text, unavailable = false) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          this.stickyATCSubmitButton.setAttribute('disabled', 'disabled');
          this.stickyATC.classList.remove('hidden');

          if (text) {
            this.submitButtonText.textContent = text;
            this.stickyATCSubmitButtonText.textContent = text;
          }

          if (unavailable) {
            // We are hiding the sticky ATC if unavailable as there is no Attentive app state to handle non existent products
            this.stickyATC.classList.add('hidden');
            this.stickyATCSubmitButtonPrice.classList.add('hidden');
          }
        } else {
          this.stickyATC.classList.remove('hidden');
          this.submitButton.removeAttribute('disabled');
          this.stickyATCSubmitButton.removeAttribute('disabled');
          this.stickyATCSubmitButtonPrice.classList.remove('hidden');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          this.stickyATCSubmitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      initStickyATC() {
        const observer = new IntersectionObserver(
          ([e]) => {
            this.stickyATC.classList.toggle('active', e.boundingClientRect.top < 0);
          },
          { threshold: [1] }
        );
        observer.observe(this.submitButtonText);
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
